const Header = () => {
  return (
    <header className="app-header">
      <h1>Video Recommendation</h1>
    </header>
  );
};

export default Header;
